import script from "./ExpectedDeliveryIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpectedDeliveryIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./ExpectedDeliveryIndicator.vue?vue&type=style&index=0&id=50b6f190&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b6f190"]])

export default __exports__